module.exports = __webpack_public_path__ + "img/1448525917.4b7ca6b5.jpg";